import { IScheduled } from './ischeduled';
export interface IScheduledPeriod {
    scheduledPeriodIdentifier: string;
    start: string; // datetime string needs to convert to date when used
    end: string;
    tenantId: number;
    language: String;
    scheduled: IScheduled[];
}
